import axiosBase from 'axios';
import uuidv1 from 'uuid/v1';

const uuid = uuidv1();
const axios = axiosBase.create({
  baseURL: process.env.SVA_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  },
  responseType: 'json'  
});

const sva = async (params) => {
  params['uid'] = uuid;
  // console.log(JSON.stringify(params));

  let queryString = '';
  for(var key in params) {
    queryString += `&${key}=${params[key]}`;
  }

  try {
    const response = await axios.get(`/collect?v=1${queryString}`);
    // console.log(response);
  } catch(e) {
    // console.log(e);
  }
};

export default sva;